import { SubpageLayout2018 } from '../subpageLayout';

export default function ContactUs2018Zh() {
  return (
    <SubpageLayout2018 lang="zh" title="聯絡" page="contact_us">
      <div className="contact_us para_introduction">
        <h1>聯絡</h1>
        <div className="contact_subhead_2">活動及獎項查詢</div>
        <div className="contact_card_container">
          <div className="contact_card">
            +852 2564 0943
            <br />
            <a href="mailto:smartcityawards@etnet.com.hk">smartcityawards@etnet.com.hk</a>
          </div>
        </div>
      </div>
    </SubpageLayout2018>
  );
}

